<template>
  <div class="business">
    <!-- <MobileNav/> -->
    <div class="info-wrap">
      <div class="loading" v-if="loadingShow === true">
        <div class="loadingImg"></div>
      </div>
      <div class="info-table">
        <div class="info-title">
          <el-button type="text" icon="el-icon-back" class="back" @click="back()">返回</el-button>
          <span>服务器</span>
        </div>
        <div class="info-list">
          <div class="list-item" v-for="(item,index) in thisPage" :key="index">
            <div class="item_title server">{{item.name}}</div>
            <div ref="cpu"></div>
            <div ref="mem"></div>
            <div class="tableLike">
              <img :src="getLike(item.name)" @click="addLikes(item.name)" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MobileNav from "../MobileNav";
const likeImg = require("@/assets/like.png");
const unlikeImg = require("@/assets/unlike.png");
import { setUserInfo } from '@/js/utils'
export default {
  components: {
    MobileNav
  },
  data() {
    return {
      showTime: "",
      servers: [],
      thisPage: [],
      pageTotal: null,
      pageNum: 1,
      pageCount: 5,
      actUser: false,
      hideOn: -1,
      loadingShow: true,
      likeText: []
    };
  },
  mounted() {
    var me = this;
    this.loadingShow = true;
    me.getShowTime();
    me.getServers();
    me.getLikeServer();
    setInterval(me.getShowTime, 1000);
    //阻止冒泡事件
    document.addEventListener("click", e => {
      if (e.target.className != "userData") {
        this.actUser = false;
      }
    });
    if (!me.ifLogin) {
      me.$router.push({ path: "/web" });
      setTimeout(function() {
        me.loadingShow = false;
      }, 500);
    }
  },
  sockets: {
    connect: function() {
      var token = localStorage.getItem("jwt");
      if (token) {
        this.$socket.emit("authenticate", { token });
      }
    },
    authenticated: function(data) {
      var token = localStorage.getItem("jwt");

      this.$socket.emit("queryUser", token);
    },
    unauthorized: function(error) {
      console.log('unauthorizederror :>> ', error );
      if (error.message === 'jwt expired') {
        this.$router.push({ path: "/" });
      }
    },
    userInfo: function(data) {
      setUserInfo.call(this, data)
      this.getServers();
      this.getLikeServer();
    },
    serversjson: function(data) {
      var me = this;
      me.servers = data.servers;
      me.pageInit();
      setTimeout(function() {
        me.loadingShow = false;
      }, 500);
    },
    getLikeServer(data) {
      var data = data[0].attentionServer;
      console.log("data", data);
      if (!data) {
        this.likeText = [];
      } else {
        if (data == "[20,21]" || data == "[21,20]") {
          this.likeText = [20, 21];
        } else if (data == "[20]") {
          this.likeText = [20];
        } else if (data == "[21]") {
          this.likeText = [21];
        }
      }
    },

  },
  methods: {
    getShowTime() {
      var me = this;
      var nowTime = new Date();
      var year = nowTime.getFullYear();
      var month = nowTime.getMonth() + 1;
      var date = nowTime.getDate();
      var hour = nowTime.toLocaleTimeString();
      me.showTime = year + "-" + month + "-" + date + " " + hour;
    },
    getLikeServer() {
      var me = this;
      me.$socket.emit("getLikeServer", this.$store.state.userName);
    },
    getServers() {
      var me = this;
      me.$socket.emit("serversjson");
    },
    pageInit() {
      var me = this;
      me.thisPage = me.servers.slice(
        (me.pageNum - 1) * me.pageCount,
        me.pageNum * me.pageCount
      );
      me.pageTotal = Math.ceil(me.servers.length / me.pageCount);
      this.$nextTick(() => {
        this.drawCharts();
      });
    },

    // 绘制图表
    drawCharts() {
      var me = this;
      for (var i in this.$refs["cpu"]) {
        var myChart = this.$echarts.init(this.$refs["cpu"][i]);
        myChart.setOption({
          textStyle: {
            color: "#fff"
          },
          title: {
            text: "CPU",
            textStyle: {
              color: "#fff",
              fontSize: 12
            }
          },
          tooltip: {},
          xAxis: {
            type: "category",
            axisLine: {
              show: false
            }
          },
          yAxis: {
            type: "value",
            axisLine: {
              show: false
            },
            axisLabel: {
              formatter: `{value}%`,
              margin: 2
            },
            splitLine: {
              show: false
            }
          },
          series: [
            {
              data: me.servers[i].cpuUsageList.map(function(ele, i, arr) {
                return parseFloat(ele);
              }),
              type: "line",
              smooth: true,
              lineStyle: {
                color: "#409eff"
              },
              itemStyle: {
                color: "#309eff"
              }
            }
          ]
        });
      }
      for (var i in this.$refs["mem"]) {
        var myChart = this.$echarts.init(this.$refs["mem"][i]);
        myChart.setOption({
          textStyle: {
            color: "#fff"
          },
          title: {
            text: "内存",
            textStyle: {
              color: "#fff",
              fontSize: 12
            }
          },
          tooltip: {},
          xAxis: {
            type: "category",
            axisLine: {
              show: false
            }
          },
          yAxis: {
            type: "value",
            axisLine: {
              show: false
            },
            axisLabel: {
              formatter: `{value}%`,
              margin: 2
            },
            splitLine: {
              show: false
            }
          },
          series: [
            {
              data: me.servers[i].memUsageList.map(function(ele, i, arr) {
                return parseFloat(ele);
              }),
              type: "line",
              smooth: true,
              lineStyle: {
                color: "#409eff"
              },
              itemStyle: {
                color: "#309eff"
              }
            }
          ]
        });
      }
    },
    handleCurrentChange(val) {
      var me = this;
      me.pageNum = val;
      me.pageInit();
    },
    actUsers(e) {
      this.hideOn = e;
      this.actUser = !this.actUser;
    },
    getLike(item) {
      var me = this;
      if (item == "服务器1") {
        if (me.likeText[0] == 20 || me.likeText[1] == 20) {
          return likeImg;
        } else {
          return unlikeImg;
        }
      } else {
        if (me.likeText[0] == 21 || me.likeText[1] == 21) {
          return likeImg;
        } else {
          return unlikeImg;
        }
      }
    },
    addLikes(data) {
      var me = this;
      var text;
      console.log(data, me.likeText.length);
      if (data == "服务器1") {
        if (me.likeText.length == 2) {
          me.likeText = [21];
        } else if (me.likeText.length == 1) {
          if (me.likeText[0] == 20) {
            me.likeText = [];
          } else {
            me.likeText = [20, 21];
          }
        } else {
          me.likeText = [20];
        }
      } else if (data == "服务器2") {
        if (me.likeText.length == 2) {
          me.likeText = [20];
        } else if (me.likeText.length == 1) {
          if (me.likeText[0] == 20) {
            me.likeText = [20, 21];
          } else {
            me.likeText = [];
          }
        } else {
          me.likeText = [21];
        }
      }
      me.$socket.emit("changeAttentionServer2", {
        data: me.likeText,
        name: me.$store.state.userName
      });
      console.log("likeText", me.likeText);
    },
    back() {
      this.$router.go(-1);
    }
  },
  computed: {
    ifLogin() {
      return this.$store.state.ifLogin;
    },
    userName() {
      return this.$store.state.userName;
    },
    userImage() {
      return this.$store.state.userImage;
    }
  }
};
</script>

<style lang="less" scoped>
.business {
  padding-bottom: 20px;
  .tc {
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    float: right;
    width: 200px;
  }
  .info-wrap {
    display: flex;
    margin: 0 auto;
    width: 90vw;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-top: 2vh;
    .loading {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 999;
      background-color: #181e26;
      .loadingImg {
        width: 320px;
        height: 240px;
        background-image: url(../../assets/loading.gif);
        background-size: 100% 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        line-height: 420px;
        color: #21a2f5;
        font-size: 18px;
      }
    }
    .info-top {
      color: #fff;
      display: flex;
      width: 100%;
      height: 10vh;
      justify-content: center;
      align-items: center;
      .info-top-title {
        color: #fff;
        font-size: 14px;
        text-align: left;
        height: 3vh;
        margin: 2vh 1vw;
        font-weight: 350;
      }
    }
    .info-table {
      font-size: 14px;
      text-align: left;
      // background-color: #20252f;
      padding: 0.5vw 1.8vw 0.5vw 1vw;
      overflow: hidden;
      width: 100%;
      margin-bottom: 2vh;
      .info-title {
        position: relative;
        text-align: center;
        // height: 2.6vh;
        line-height: 5vh;
        color: #fff;
        margin-bottom: 4vh;
        span {
          display: inline-block;
          width: 40vw;
          text-align: center;
          color: #fff;
          font-size: 18px;
        }
        .back {
          position: absolute;
          color: #fff;
          left: 0;
        }
      }
      .info-list {
        width: 100%;
        color: #fff;
        display: flex;
        flex-direction: column;
        .list-title {
          width: 100%;
          display: flex;
          margin: 20px 0;
          span {
            flex: 1;
            text-align: center;
          }
        }
        .list-item {
          align-items: center;
          padding: 10px 0;
          margin-top: 20px;
          position: relative;
          background-color: #20252f;
          justify-content: center;
          align-items: center;
          box-shadow: 0px 0px 10px #000;
          border-radius: 10px;
          text-align: center;
          div {
            display: inline-block;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 250px;
            padding-left: 8%;
          }
          .item_title {
            height: 50px;
            text-align: center;
            padding-top: 20px;
            padding-left: 0;
          }
          .server {
            width: 55px;
            height: 55px;
            background-size: 70%;
            background-position: center;
            line-height: 70px;
            // display: inline-block;
            text-align: center;
            background-repeat: no-repeat;
            background-image: url(../../assets/serverIcon.png);
          }
          .tableLike {
            height: 50px;
            padding: 0;
            img {
              width: 25px;
              cursor: pointer;
            }
          }
        }
        .list-item:first-child {
          margin-top: 10px;
        }
        .list-item:nth-child(even) {
          background: rgba(117, 176, 243, 0.3);
        }
      }
    }
  }
  .ysxy {
    color: #fff;
    font-size: 16px;
    text-decoration: none;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/mobile/mobileServer.vue